export function isInDarkMode() {
  const mode = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    ? true
    : false;
  return mode;
}